import DrawerBookingForm from '@/app/modules/bookings/components/drawer-booking-form/drawer-booking-form.vue';
// import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import TableMock from '@shared/components/mocks/table-mock/table-mock.vue';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import { Booking } from '@bookings/interfaces/booking';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import AuthorizationHelper from '@auth/services/authorization.helper';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';
import ModulesHelper from '@core/services/modules.helper';
import BookingRenewModal from '@bookings/components/modals/booking-renew-modal.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import BulkEditModal from '@shared/components/modals/bulk-edit-modal/bulk-edit-modal.vue';

library.add(faPlus);

@Component({
  name: 'bpc-booking-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-table-mock': TableMock,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-select': Select,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-booking-form': DrawerBookingForm,
    'bpc-extended-filter': ExtendedFilter,
    'bpc-std-form': StdForm,
    'bpc-drawer-modal': DrawerModal,
    'bc-booking-renew-modal': BookingRenewModal,
    'bpc-bulk-edit-modal': BulkEditModal,
  },
})
export default class BookingTable extends mixins(AbstractTable, SendMessageUsingTemplateMixin) {
  $refs: AbstractTable['$refs'] & {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdCancelForm: InstanceType<typeof StdForm> & {
      formModel: AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  @Prop(Array) readonly value: any[];
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;
  @Prop({ type: Boolean, default: true }) readonly showTableHeader: boolean;
  @Prop({ type: Boolean, default: false }) readonly isInput: boolean;
  @Prop({
    type: Array,
    default() {
      return ['configLoaded', 'paginationLoaded', 'orderLoaded', 'urlParametersLoaded'];
    },
  })
  readonly initialFlagsToCheck: string[];
  @Prop(Array) readonly filters: any[];
  @Prop({ type: String, default: 'api' }) readonly mode: string;
  @Prop(String) readonly fieldForStorage: string;
  @Prop(Number) readonly activityGroupId: number;
  @Prop({ type: Boolean, default: false }) readonly withDraft: boolean;
  @Prop({ type: String, default: 'default-edit' }) readonly editFormConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly createFormConfigName: string;
  @Prop({ type: String, default: 'cancel-bookings' }) readonly cancelFormConfigName: string;

  public entity: Booking = null;
  public entityName = 'booking';
  public pluralEntityName = 'bookings';
  public showBookingRenewModal = false;
  public showBulkEditModal = false;
  public bulkEditDataToShow = [['code']];
  extraFieldsToBulkEdit: object = { defaultValueSwitchModel: {} };
  extraDataToBulkEdit: object = {};

  beforeMount() {
    this.flagsToCheckBeforeLoadEntities = this.initialFlagsToCheck;
  }

  public customPageActions = {
    bulkSendMessageUsingTemplate: {
      activated: false,
      type: 'action',
      icon: 'envelope', //'times',
      variant: 'info',
      text: 'send_message_using_template',
      show: false,
      event: 'bulk-send-message-using-template',
      selectElements: true,
      tag: 'right',
      permissions: ['bulk_message'],
    },
    create: {
      activated: false,
      type: 'action',
      icon: 'plus',
      variant: 'success',
      text: 'create-new',
      show: true,
      event: 'search',
      selectElements: false,
      tag: 'right',
      permissions: ['store'],
    },
    bulkCancel: {
      activated: false,
      type: 'action',
      icon: 'ban', //'times',
      variant: 'danger',
      text: 'cancel',
      show: false,
      event: 'bulk-cancel',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_cancel'],
    },
    bulkRenew: {
      activated: false,
      type: 'action',
      icon: 'redo',
      variant: 'info',
      text: 'renew',
      show: false,
      event: 'bulk-renew',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_cancel'], //#Fix me
    },
    bulkAddToContract: {
      activated: false,
      type: 'action',
      icon: 'sticky-note',
      variant: 'info',
      text: 'add-to-contract',
      show: false,
      event: 'bulk-add-to-contract',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_cancel'], //#Fix me
    },
  };

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
  }

  mounted() {
    this.$root.$on('bookingEventSaved', event => {
      this.$refs.provider.getEntities();
    });
    this.$root.$on('bookingSaved', event => {
      this.$refs.provider.getEntities();
    });
    this.$root.$on('refresh-table-after-add-orders-to-pos', () => {
      this.refreshEntitiesAfterOrdersAddedToPosCheckout();
    });

    // For messages with templates
    const templatesRequest = [this.getAllowedTemplatesForSendMessage()];

    Promise.all(templatesRequest).then(res => {
      this.updateRowActions();
      this.updatePageActions();
    });
  }
  // updated () { }
  destroyed() {
    this.$root.$off('bookingEventSaved');
    this.$root.$off('bookingSaved');
    this.$root.$off('refresh-table-after-add-orders-to-pos');
  }

  updateModel(): void {
    this.model = this.$refs?.provider?.items;
  }

  onFormSaved(event) {
    this.$refs.provider.getEntities();
    this.onFormClose();
    if (this.nextAction === 'pay') {
      const orders = [];
      event.data?.bookingEvents?.forEach(bookingEvent => {
        bookingEvent.orders.forEach(order => orders.push(order));
      });
      this.ordersAvailableToPosCheckout = orders;
      this.selectedOrdersToPosCheckout = orders;
      this.selectedContactIdToPosCheckout = event.data.contact_id;
      this.selectedPriceCategoryIdToPosCheckout = event.data.price_category_id;
      this.selectedInvoiceIdToPosCheckout = this.$store.getters['pos/currentTicketId'];
      this.openExportPosCheckoutModal();
    }
    this.setNextAction('');
  }

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }
    this.customPageActions.bulkCancel.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;

    this.customPageActions.bulkRenew.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;

    this.customPageActions.bulkAddToContract.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated(ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME);

    this.customPageActions.bulkSendMessageUsingTemplate.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);

    // Check Permissions
    for (const activatedPageAction of this.config.data.activatedPageActions) {
      if (
        this.customPageActions[activatedPageAction] &&
        this.customPageActions[activatedPageAction]['permissions']
      ) {
        const permissions = [];
        this.customPageActions[activatedPageAction]['permissions'].forEach(permissionName => {
          permissions.push(
            {
              name: AuthorizationHelper.getPermissionName(
                permissionName,
                (this.permissionEntityNameToUse
                  ? this.permissionEntityNameToUse
                  : this.pluralEntityName
                ).replace('-', '_'),
              ),
            },
            {
              name: AuthorizationHelper.getPermissionName(
                permissionName,
                (this.permissionEntityNameToUse
                  ? this.permissionEntityNameToUse
                  : this.pluralEntityName
                ).replace('-', '_'),
                true,
              ),
            },
          );
        });
        this.customPageActions[activatedPageAction][
          'activated'
        ] = this.$authorizationService.hasPermissions(permissions);
      }
    }
  }

  get pageActions() {
    return {
      ...this.customPageActions,
      ...this.defaultPageActions,
    };
  }

  public customRowActions = {
    sendMessageUsingTemplate: {
      activated: true,
      type: 'action',
      icon: 'envelope',
      show: true,
      event: 'send-message-using-template',
      text: 'send_message_using_template',
      permissions: ['send'],
    },
  };

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'send-message-using-template':
        this.onSendMessageUsingTemplate($event.item.item);
        break;
    }
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.sendMessageUsingTemplate.show =
      this.tableIsNotFilteredByTrashedElements() &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);
    entity.actions.softDelete.show =
      this.tableIsNotFilteredByTrashedElements() &&
      this.$authorizationService.hasPermission('delete_bookings');
  }

  constructor() {
    super();
  }

  showDrawer() {
    this.$bpcStorage.clear('booking-events');
    this.showDrawerSection = true;
  }

  onBulkCancel() {
    this.$bvModal.show('modal-cancel-bookings');
  }

  customOnPageAction($event: string) {
    switch ($event) {
      case 'search':
        this.onNew();
        break;
      case 'bulk-cancel':
        this.onBulkCancel();
        break;
      case 'add-booking':
        this.onAddBooking();
        break;
      case 'bulk-send-message-using-template':
        this.onBulkSendMessageUsingTemplate(this.selection);
        break;
      case 'bulk-renew':
        this.onBulkRenew();
        break;
      case 'bulk-add-to-contract':
        this.onBulkAddToContract();
        break;
    }
  }

  onBulkEdit() {
    if (!this.emitOnBulkEdit) {
      this.showBulkEditModal = true;
    } else {
      this.$emit('on-bulk-edit', this.selection);
    }
  }

  onCloseBulkEdit() {
    this.showBulkEditModal = false;
  }
  onFinishBulkEdit() {
    this.$refs.provider.getEntities();
  }
  onBookingSoftDeleted() {
    this.$refs.provider.getEntities();
  }
  onBookingCanceled() {
    this.$refs.provider.getEntities();
  }
  onBookingConfirmed() {
    this.$refs.provider.getEntities();
  }
  onBookingRefused() {
    this.$refs.provider.getEntities();
  }

  onPaymentCreated() {
    this.$refs.provider.getEntities();
    this.showDrawerSection = false;
  }

  showCancellingSpinner: boolean = false;
  onConfirmCancelBookings() {
    this.showCancellingSpinner = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('booking');
    this.$bpcApi
      .post(basePath + '/cancel', {
        bookings: this.selection,
        cancelReason: this.$refs.stdCancelForm.formModel['cancel_reason'],
        cancelReasonDescription: this.$refs.stdCancelForm.formModel['cancel_reason_description'],
        cancelOrders: this.$refs.stdCancelForm.formModel['cancel_orders'],
        notify_by_email:
          'notify_by_email' in this.$refs.stdCancelForm.formModel
            ? this.$refs.stdCancelForm.formModel['notify_by_email']
            : true,
      })
      .subscribe(
        res => {
          this.$refs.provider.getEntities();
          this.showCancellingSpinner = false;
          this.$bvModal.hide('modal-cancel-bookings');
        },
        error => {
          this.showCancellingSpinner = false;
          this.$bvModal.hide('modal-cancel-bookings');
        },
      );
  }

  onCloseRenewModal() {
    this.showBookingRenewModal = false;
  }

  onFinishRenew() {
    this.$refs.provider.getEntities();
  }

  onCloseModal() {
    this.$bvModal.hide('modal-cancel-bookings');
  }

  onAddBooking() {
    this.entity = null;
    this.showDrawer();
    this.showForm = true;
  }

  onBulkRenew() {
    this.showBookingRenewModal = true;
  }

  onBulkAddToContract() {
    this.showBookingRenewModal = true;
  }
}
